import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Container,
  Row, Col,
  Card,
  CardBody,
  Button, Form,
  FormInput, FormGroup
} from "shards-react";

import { providerActions, getCurrentProvider } from '../core/providers'
import  LoadingIndicator from '../components/common/loading-indicator'

class Login extends Component{

  navigateToPath(){
    const { navigateToPath } = this.props
    navigateToPath('/home')
  }

  componentWillMount() {
    const { user, authenticated, checked, provider } = this.props

    if(!provider.isPending) {
        if ( authenticated && checked && provider && !provider.error ) {
            this.props.navigateToPath('/home')
        }
        else if (provider.error) {
            this.props.navigateToPath('/401')
        }
    }
  }

  componentWillUpdate(nextProps ) {
    const { user, authenticated, checked, provider } = nextProps

    if(!provider.isPending) {
        if ( authenticated && checked && provider && !provider.error ) {
            this.props.navigateToPath('/home')
        }
        else if ( provider.error ) {
            this.props.navigateToPath('/401')
        }
    }
  }

  render() {

    return (<Container className="main-content-container h-100 px-4 container-fluid">
      <Row className="h-100 no-gutters">
        <Col className="auth-form mx-auto my-auto col-md-5 col-lg-4">
            <LoadingIndicator className="text-center" style={{ "marginTop": "15px", "display": "block" }}/>
        </Col>
      </Row>
    </Container>);

    return (
      <Container className="main-content-container h-100 px-4 container-fluid">
        <Row className="h-100 no-gutters">
          <Col className="auth-form mx-auto my-auto col-md-5 col-lg-4">
            <Card>
              <CardBody style={{ overflow: 'hidden',  boxShadow: 'inset 0 4px 0 0 #007bff', borderRadius: '.625rem' }}>
                <img
                className="auth-form__logo d-table mx-auto mb-3"
                src={require("../images/logo_login.png")}
                alt="Galeno"
                />
                <h5 className="auth-form__title text-center mb-4">Iniciar Sesión</h5>
                <Form>
                  <FormGroup>
                    <label htmlFor="#email">Email</label>
                    <FormInput type="email" id="#email" placeholder="Email" />
                  </FormGroup>
                  <FormGroup>
                    <label htmlFor="#password">Contraseña</label>
                    <FormInput type="password" id="#password" placeholder="Contraseña" />
                  </FormGroup>
                  <Button onClick={ this.navigateToPath.bind(this)} className="d-table mx-auto btn-accent btn-pill">Ingresar</Button>
                </Form>
              </CardBody>
            </Card>
            <div className="auth-form__meta d-flex mt-4">
            <a href="/forgot-password" style={{     fontWeight: 400, color: '#818ea3' }}>Recuperar Contraseña</a>
            </div>
          </Col>
        </Row>
      </Container>
    )
  }
}


//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {
  const { session, provider } = state
  return {
    provider: getCurrentProvider(state, props),
    checked: session.checked,
    authenticated: session.authenticated,
    user: session.user,
    provider
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(providerActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);
